export default function(StringText){
    const regex= new RegExp('[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\\\\.[A-Za-z]{2,4}')
    if(regex.test(StringText)!==true) return false
    else return true
}
